import { getFetchMethod, HttpMethod } from 'src/api/common';
import type { EnvConfig } from 'src/types/config';

export const getConfigJson = async <Data = EnvConfig>() =>
  getFetchMethod<Data>({
    url: `/assets/public/config.${import.meta.env.VITE_PROJECT_ENV}.json?_=${Date.now()}`,
    method: HttpMethod.GET,
    data: null,
    isTransformToCamelCase: false,
    cache: 'no-store',
  });
